import './app.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import Amplify from 'aws-amplify';
import { useSelector } from 'react-redux';
import AccountManagement from './components/views/account-management/account-management';
import AccountOverview from './components/account-overview/account-overview';
import awsconfigprod from './aws-exports-prod';
import awsconfigstage from './aws-exports-stage';
import awsconfiglocal from './aws-exports-local';
import awsconfigqa from './aws-exports-qa';
import ScrollToTop from './utilities/scrollToTop';
import useAuthSession from './utilities/hooks/useAuthSession';

const env = 'prod';
/* --- AWS AUTH LOCAL VS PROD --- */
if (env === 'prod') {
  Amplify.configure(awsconfigprod);
} else if (env === 'stage') {
  Amplify.configure(awsconfigstage);
} else if (env === 'qa') {
  Amplify.configure(awsconfigqa);
} else if (env === 'dev_local') {
  Amplify.configure(awsconfiglocal);
}
const App = () => {
  const isLoggedIn =
    useSelector((state) => !!state.accounts.customerId);

  const { isAuthChecked } = useAuthSession();

  return isAuthChecked ? (
    <Router basename="/account">
      <ScrollToTop />
      {isLoggedIn ? (
        <AccountOverview />
      ) : (
        <AccountManagement />
      )}
    </Router>
  ) : null;
};

export default App;
